// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2S9QS","col":"styles_col__2B__w"};